import { render } from "./SimpleTable.vue?vue&type=template&id=53b3e17b&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"

import "./SimpleTable.vue?vue&type=style&index=0&id=53b3e17b&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b3e17b"]])

export default __exports__